<template>
  <div id="app">
    <bodyHead v-if="HeadFooter"></bodyHead>
    <router-view/>
    <bodyFooter v-if="HeadFooter"></bodyFooter>
  </div>
</template>

<script>
  import bodyHead from '@/components/header/header'
  import bodyFooter from '@/components/footer/footer'

  export default {
    name: 'App',
    components: {
      bodyHead,
      bodyFooter
    },
    created () {
      // 在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem('state')) {
        this.$store.replaceState(Object.assign({}, this.$store.state,
          JSON.parse(sessionStorage.getItem('state'))))
      }
      // 页面刷新时将state数据存储到sessionStorage中
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('state', JSON.stringify(this.$store.state))
      })
    },
    computed: {
      HeadFooter: function () {
        return this.$store.state.HeadFooter
      }
    }
  }
</script>

<style>
  @import "../src/common/publick.css";

  #app {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue